import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

const sellerInfoQueryKey = ["seller-info"] as const;
type SellerInfo = Awaited<ReturnType<typeof apiClient.getSellerInfo>>;
type Options = Omit<UseQueryOptions<SellerInfo>, "queryKey" | "queryFn">;

export const useSellerInfo = (options: Options = {}) => {
  return useQuery({
    queryKey: sellerInfoQueryKey,
    queryFn: async () => await apiClient.getSellerInfo(),
    staleTime: 30000, // Consider stale after 30 seconds
    ...options,
  });
};
